module.exports = __webpack_public_path__ + "img/National-Assembly-Bulgaria.0e061859.jpg";